import notificationTypes from '../../../../../common/constants/mailNotificationTypes';

/**
 *
 * @param {object} notifs
 * @param {boolean} notifs.lowBudgetAlerts
 * @param {boolean} notifs.newsletter
 * @param {boolean} notifs.dailyStats
 * @param {boolean} notifs.keywordAlerts
 * @param {boolean} notifs.campaignStopAlerts
 *
 * @returns {object} result
 * @returns {boolean} result.monthlyNotification
 * @returns {string[]} result.financialNotifications
 * @returns {string[]} result.campaignRelatedNotifications
 */

export default function transformToClientNotificationTypes(notifs) {
  const financialNotifications = [];

  if (notifs[notificationTypes.LOW_BUDGET])
    financialNotifications.push(notificationTypes.LOW_BUDGET);
  if (notifs[notificationTypes.DAILY_STATS])
    financialNotifications.push(notificationTypes.DAILY_STATS);

  const campaignRelatedNotifications = [];

  if (notifs[notificationTypes.KEYWORD_ALERTS])
    campaignRelatedNotifications.push(notificationTypes.KEYWORD_ALERTS);
  if (notifs[notificationTypes.CAMPAIGNS_STOP_ALERTS])
    campaignRelatedNotifications.push(notificationTypes.CAMPAIGNS_STOP_ALERTS);

  return {
    monthlyNotification: notifs[notificationTypes.NEWSLETTER],
    financialNotifications,
    campaignRelatedNotifications,
  };
}
